import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import {
  MatDialogClose,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { LoanAiService } from '../../loanAiService';
import { Subject } from 'rxjs';
import { MarkdownModule } from 'ngx-markdown';
export class Message {
  constructor(
    public author: string,
    public content: string,
    public msgData: any,
    public showWaiting: boolean,
    public errorMessage: boolean,
    public errorText: string
  ) {}
}
@Component({
  selector: 'app-chatbot-dialog',
  imports: [
    MatButtonModule,
    FormsModule,
    CommonModule,
    MatDialogClose,
    MatIcon,
    MatExpansionModule,
    MarkdownModule
  ],
  standalone: true,
  templateUrl: './chatbot-dialog.component.html',
  styleUrl: './chatbot-dialog.component.scss',
})
export class ChatbotDialogComponent {
  static documentOpen$ = new Subject<any>();
  minimized = false;
  closeDialog() {
    this.service.persistMemory(this.getChatSessionId()).subscribe((data) => {});
  }
  conversation = new Subject<Message[]>();
  messages: Message[] = [];
  value: string = '';
  year = '';
  errorText = '';
  quarter = '';
  doc_run_id: any;

  constructor(
    private router: Router,
    private service: LoanAiService,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ChatbotDialogComponent>
  ) {
    this.route.queryParams.subscribe((queryParams) => {
      this.year = queryParams['year'];
      this.quarter = queryParams['quarter'];
      this.doc_run_id = queryParams['doc_run_id'];
    });
  }
  ngOnInit() {
    this.dialogRef.addPanelClass('normal-dialog');
    this.service
      .startChat(
        this.quarter,
        this.year,
        this.doc_run_id,
        this.getChatSessionId()
      )
      .subscribe((data) => {
        // console.log(data);
      });
    this.conversation.subscribe((val) => {
      this.messages = this.messages.concat(val);
    });
  }
  getChatSessionId() {
    return sessionStorage.getItem('chat-id')?.toString() || '';
  }
  
  toggleMinimize() {
    this.minimized = !this.minimized;
    const dialogWidth = '450px';
    if (this.minimized) {
      this.dialogRef.updateSize(dialogWidth, '10px');
      this.dialogRef.addPanelClass('minimized-dialog');
      this.dialogRef.removePanelClass('normal-dialog');
    } else {
      this.dialogRef.updateSize(dialogWidth, '90vh');
      this.dialogRef.addPanelClass('normal-dialog');
      this.dialogRef.removePanelClass('minimized-dialog');
    }
  }

  boldTextBeforeColonInPTag(markdown: string): string {
    return markdown.replace(
      /<p>([^<]*?:)([^<]*)<\/p>/g,
      (_match, beforeColon, afterColon) => `<p><strong>${beforeColon}</strong>${afterColon}</p>`
    );
  }

  getBotAnswer(msg: string) {
    let userMessage = new Message('user', msg, '', true, false, '');
    this.conversation.next([userMessage]);
    this.service.continueChat(msg, this.getChatSessionId()).subscribe(
      (data) => {
        if (data.status === 'success') {
          let msgData = [];
          if (data.docs && Array.isArray(data.docs)) {
            msgData = data.docs;
          } else if (data.chunks && Array.isArray(data.chunks)) {
            msgData = [{ original_filename: '', doc_category: '', chunks: data.chunks }];
          }
          let processedAnswer = this.boldTextBeforeColonInPTag(data.chat_answer);
          let botMessage = new Message(
            'bot',
            processedAnswer,
            msgData,
            false,
            false,
            ''
          );
          userMessage.showWaiting = false;
          this.conversation.next([botMessage]);
          if (data.docs && Array.isArray(data.docs)) {
            botMessage.msgData = data.docs.map((doc: any) => ({
              ...doc,
              expanded: false,
              chunks: Array.isArray(doc.chunks)
                ? doc.chunks.map((chunk: any) => ({ ...chunk, expanded: false }))
                : []
            }));
          }
        } else {
          userMessage.showWaiting = false;
          userMessage.errorMessage = true;
          userMessage.errorText = data.message;
        }
      },
      (error) => {
        userMessage.showWaiting = false;
        userMessage.errorMessage = true;
        userMessage.errorText =
          'An error occured getting response from LLM client';
      }
    );
  }

  toggleDocExpand(msg: any) {
    msg.expanded = !msg.expanded;
  }

  toggleChunkExpand(chunk: any) {
    chunk.expanded = !chunk.expanded;
  }

  sendMessage() {
    this.getBotAnswer(this.value);
    this.value = '';
  }
  openDoc(url: any) {
    window.open(url, '_blank');
  }

  getPageNumber(msg: any): string {
    if (msg.chunks && msg.chunks.length > 0) {
      const pages = msg.chunks
        .map((chunk: any) => chunk.page_number)
        .join(', ');
      return `Doc Category: ${msg.doc_category} | Page: ${pages}`;
    }
    return '';
  }
  // Fetches the PDF via loanAiService and displays it.
  openDocument(row: any) {
    ChatbotDialogComponent.documentOpen$.next({ type: 'start' });
    this.service.clearPdfViewer();
    this.service._dispalyDoc(row.doc_id).subscribe((response: any) => {
      const data = response && response.body ? response.body : response;
      const blob = new Blob([data], { type: 'application/pdf' });
      let pageNumber = 1;
      if (row.chunks && row.chunks.length > 0 && row.chunks[0].page_number) {
        pageNumber = row.chunks[0].page_number;
      }
      this.service.sendPdfBlob(blob, pageNumber);
      ChatbotDialogComponent.documentOpen$.next({ type: 'loaded' });
    });
  }

  getImage(msg: any): string {
    // Replace with your actual logic to get the image URL
    return msg.original_filename.endsWith('.pdf')
      ? 'pdf-icon.png'
      : 'exls-icon.png';
  }
}
